import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const HubSpotConfigurationFormSchema = oz.object({
  autoImportCustomers: oz.boolean(),
  autoImportContracts: oz.boolean(),
});

export type HubSpotConfigurationFormValues = oz.infer<typeof HubSpotConfigurationFormSchema>;
export type HubSpotConfigurationControl = Control<HubSpotConfigurationFormValues>;
